import Big from "big.js";

/**
 * Calculates the final price for a retail sale by applying the retail markup rate.
 *
 * @param {number} basePrice - The base price before retail markup
 * @param {Big.BigSource} retailMarkupPct - The retail markup percentage (as decimal, e.g., 0.25 for 25%)
 * @returns {Big} - The final price with retail markup applied, or the base price if no markup rate is set
 *
 * @example
 * calculateRetailPrice(100, 0.25) // Returns 125
 * calculateRetailPrice(100, 0) // Returns 100
 * calculateRetailPrice(100, null) // Returns 100
 */
export const calculateRetailPrice = (basePrice, retailMarkupPct) => {
  // If no retail rate is set (0 or null/undefined), return base price unchanged
  if (!retailMarkupPct || Big(0).eq(retailMarkupPct)) {
    return Big(basePrice);
  }

  // Apply retail markup rate
  return Big(basePrice).times(Big(1).plus(retailMarkupPct));
};
